module.exports = __webpack_public_path__ + "img/economists-white.836d8387.png";